module.exports = __webpack_public_path__ + "static/media/news-red.71764449.png";